"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, BookOpen } from "lucide-react";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const handleScrollToTools = () => {
    document.getElementById('available-writing-tools')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleScrollToWhyLeaders = () => {
    document.getElementById('why-leaders-use-army-writing-tools')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-light-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://armywritingtools.com/wp-content/uploads/2025/12/Soldier-Background-2.png)]" style={{
      backgroundAttachment: "fixed"
    }}>
        {}
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://armywritingtools.com/wp-content/uploads/2025/12/Soldier-Background-2.png)]" />
      </div>

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center">
        {}
        <h1 ref={headlineRef} className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all duration-[var(--duration-slow)] ease-out shadow-[0_4px_12px_rgba(0,0,0,0.5)] bg-black/30 backdrop-blur-sm px-6 py-4 rounded-lg ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          Mission-Ready Writing Tools for Army Leaders
        </h1>

        {}
        <p ref={subheadlineRef} className={`font-sans text-xl md:text-2xl text-white mb-10 max-w-3xl mx-auto transition-all duration-[var(--duration-slow)] ease-out delay-150 shadow-[0_2px_8px_rgba(0,0,0,0.4)] bg-black/20 backdrop-blur-sm px-6 py-3 rounded-lg ${subheadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          Generate regulation-compliant NCOERs, award citations, and counseling
          statements in seconds. Built by leaders, for leaders.
        </p>

        {}
        <div ref={ctaRef} className={`flex flex-col sm:flex-row gap-4 justify-center items-center transition-all duration-[var(--duration-slow)] ease-out delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button size="lg" onClick={handleScrollToTools} className="bg-accent text-foreground-accent hover:bg-accent-hover hover:scale-[1.02] active:bg-accent-active active:scale-100 transition-all duration-[var(--duration-fast)] ease-out shadow-medium px-8 py-4 text-lg font-semibold rounded-md">
            Get Started Now
            <ArrowRight className="size-5" />
          </Button>

          <Button size="lg" variant="outline" onClick={handleScrollToWhyLeaders} className="bg-background/10 backdrop-blur-sm text-slate-900 border-foreground-dark/30 hover:bg-background/20 hover:border-foreground-dark/50 hover:scale-[1.02] active:scale-100 transition-all duration-[var(--duration-fast)] ease-out shadow-soft px-8 py-4 text-lg font-semibold rounded-md">
            Learn More
            <BookOpen className="size-5" />
          </Button>
        </div>
      </div>
    </section>;
}